import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const OnboardingLayoutHeader = ({ className, albumFolder }) => {
  const classes = classNames({
    'onboarding-layout-header': true,
    [className]: !!className,
  });

  const accountLogo = albumFolder.account?.logo_image;

  if (!accountLogo) {
    return null;
  }

  return (
    <div className={classes}>
      <div className="onboarding-layout-header-user-logo">
        <img src={accountLogo.url} alt="" />
      </div>
    </div>
  );
};

OnboardingLayoutHeader.propTypes = propTypes;

export default OnboardingLayoutHeader;
